export const searchPhoneRoutes = [
  {
    path: '/buscar-telefone',
    name: 'SearchPhone',
    meta: {
      requiresAuth: true,
      menu: true,
      navbarActions: true,
      chat: true
    },
    component: () => import(/* webpackChunkName: 'search-phone-page' */ 'views/SearchPhonePage')
  }
]
